<template>
    <div ref="dataFilterHeight">
        <div class="data-filter">
            <!--学年筛选 filterable-->
            <div class="school-year-data-filter school-data-filter data-item-filter"
                v-if="contentObject.displayYearFilter">
                <Select v-model="filters.classyear" ref="classYearRef" placeholder="请选择学年"
                    @on-change="selectYearChange">
                    <Option v-for="item in yearList" :value="item.value" :key="item.value">{{ item.name }}</Option>
                </Select>
            </div>
            <!--时间筛选-->
            <div class="time-filter" v-if="contentObject.displayTimeFilter">
                <template v-for="(item, index) in timeData">
                    <div :style="filters.timeSolt == item.key ? buttonStyle : ''" class="button-style data-item-filter"
                        v-on:click="changeTimeSolt(item.key)">
                        {{ item.value }}
                    </div>
                </template>
            </div>
            <div v-if="filters.timeSolt == 3" class="self-data-filter data-item-filter">
                <DatePicker type="daterange" split-panels placeholder="请选择自定义日期" :editable="false"
                    @on-change="customDate" :options="datePickerOptions">
                </DatePicker>
            </div>
            <!--学段筛选：仅当用户拥有多个学段时才显示下拉（单学段或无学段不显示）-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayPhaseFilter && showPhaseFilter">
                <Select v-model="filters.phase" ref="phaseRef" placeholder="请选择学段" @on-change="selectPhaseChange">
                    <Option v-for="item in phaseOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <slot name="resourceSelect"></slot>
            <!--年级筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayGradeFilter">
                <Select v-model="filters.gradeId" ref="gradeRef" placeholder="请选择年级" @on-change="selectGradeChange">
                    <Option value="0">全部年级</Option>
                    <Option v-for="item in gradeList" :value="item.id" :key="item.id">{{ item.grade_name }}</Option>
                </Select>
            </div>
            <!--班级筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayClassFilter">
                <Select v-model="filters.classId" ref="classRef" placeholder="请选择班级" @on-change="selectClassChange">
                    <Option value="0">全部班级</Option>
                    <Option v-for="item in classList" :value="item.class_id" :key="item.class_id">
                        {{ item.grade_name + item.class_name }}
                    </Option>
                </Select>
            </div>
            <!--学科筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displaySubjectFilter">
                <Select v-model.trim="filters.subjectId" ref="subjectRef" placeholder="请选择学科"
                    @on-change="selectSubjectChange">
                    <Option value="0">全部学科</Option>
                    <Option v-for="item in subjectList" :value="item.id" :key="item.id">{{ item.subject_name }}</Option>
                </Select>
            </div>
            <!--省级区域筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayProvinceFilter">
                <Select v-model="filters.provinceId" ref="provinceRef" @on-change="onRegionChange($event, 2)" clearable
                    placeholder="全部省份" filterable>
                    <Option value="0">全部省份</Option>
                    <Option v-for="item in areaList.provinceList" :value="item.id" :key="item.id">{{ item.areaName }}
                    </Option>
                </Select>
            </div>
            <!--市级区域筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayCityFilter">
                <Select v-model="filters.cityId" ref="cityRef" @on-change="onRegionChange($event, 3)" clearable
                    placeholder="全部城市" filterable>
                    <Option value="0">全部城市</Option>
                    <Option v-for="item in areaList.cityList" :value="item.id" :key="item.id">{{ item.areaName }}
                    </Option>
                </Select>
            </div>
            <!--地区级区域筛选-->
            <div class="school-data-filter data-item-filter" v-if="contentObject.displayDistrictFilter">
                <Select v-model="filters.districtId" ref="districtRef" @on-change="onRegionChange($event)" clearable
                    placeholder="全部地区" filterable>
                    <Option value="0">全部地区</Option>
                    <Option v-for="item in areaList.districtList" :value="item.id" :key="item.id">{{ item.areaName }}
                    </Option>
                </Select>
            </div>
            <slot name="addFilterSlot"></slot>
        </div>
    </div>
</template>

<script>
import {
    findSubjectsList, findGradeList, findClassesList, findRegion, findSchoolYears
} from "../service/bigDataApi.js";

export default {
    name: "data-filter",
    props: {
        schoolId: String,
        gradeid: String,
        timeData: Array,
        timesolt: Number,
        startdate: String,
        enddate: String,
        searchParams: {
            type: Object,
            default: () => {
                return {
                    classId: "0",
                    subjectId: "0",
                    gradeId: "0",
                    phase: '0'
                };
            }
        },
        contentObject: {
            type: Object,
            default: () => {
                return {
                    displayTimeFilter: false,
                    displaySubjectFilter: false,
                    displayGradeFilter: false,
                    displayClassFilter: false,
                    displayYearFilter: false,
                    displayProvinceFilter: false,
                    displayCityFilter: false,
                    displayDistrictFilter: false,
                    displayPhaseFilter: false
                };
            }
        },
        buttonColor: String
    },
    watch: {
        contentObject: {
            handler(newValue, oldValue) {
                this.queryDataByParams()
            },
            deep: true
        }
    },
    data() {
        return {
            yearList: [],//学年列表
            subjectList: [],//学科列表
            gradeList: [],//年级列表
            classList: [],//班级列表
            phaseGradeIds: '',//当前用户学段对应的所有年级id（逗号分隔），用于"全部年级"时按学段过滤统计
            userPhase: '',//登录用户学段（从 store 同步，供模板限定学段下拉）
            // 地区列表
            areaList: {
                provinceList: [],
                cityList: [],
                districtList: []
            },
            //筛选参数
            filters: {
                timeSolt: this.timesolt == undefined ? "0" : this.timesolt,
                startDate: this.startdate == undefined ? "" : this.startdate,
                endDate: this.enddate == undefined ? "" : this.enddate,
                subjectId: this.searchParams.subjectId || '0',
                // gradeId: this.gradeid==undefined?"0":this.gradeid,
                gradeId: this.searchParams.gradeId || '0',
                classId: this.searchParams.classId || '0',
                classyear: '',
                phase: this.searchParams.phase,
                provinceId: '',
                cityId: "",
                districtId: '',
                phaseGradeIds: ''//当前学段所有年级id，父组件在gradeId为'0'时用它按学段过滤统计
            },
            buttonStyle: {
                background: this.buttonColor,
                color: "#fff",
                borderColor: this.buttonColor
            },   //按钮样式
            datePickerOptions: {
                disabledDate: (date) => {
                    if (this.filters.timeSolt === 3 && this.filters.classyear) {
                        // 解析学年字符串，例如 "2024-2025学年"
                        const yearMatch = this.filters.classyear.match(/(\d{4})-(\d{4})/);
                        if (yearMatch) {
                            const startYear = parseInt(yearMatch[1]); // 开始学年，例如 2024
                            const endYear = parseInt(yearMatch[2]);   // 结束学年，例如 2025
                            
                            // 设置时间范围：开始学年的8月10日 到 结束学年的8月10日
                            const startTime = new Date(startYear, 7, 10); // 月份从0开始，7表示8月
                            const endTime = new Date(endYear, 7, 10);
                            
                            // 禁用不在学年时间范围内的日期
                            return date && (date < startTime || date > endTime);
                        }
                    }
                    // 默认禁用未来日期
                    return date && date.valueOf() > Date.now();
                }
            }
        }
    },
    computed: {
        // 是否显示学段下拉：仅当用户拥有多个学段（逗号分隔）时显示
        showPhaseFilter() {
            let p = this.userPhase;
            return p && p.indexOf(',') !== -1;
        },
        // 学段下拉选项：根据登录用户学段限定范围（用户只有高中就只显示高中）
        phaseOptions() {
            let allOpts = [
                { value: '1', label: '小学' },
                { value: '2', label: '初中' },
                { value: '3', label: '高中' }
            ];
            let userPhase = this.userPhase;
            if (!userPhase) {
                // 无学段限制，显示全部（含"全部学段"）
                return [{ value: '0', label: '全部学段' }].concat(allOpts);
            }
            let arr = userPhase.split(',');
            let opts = [{ value: '0', label: '全部学段' }];
            allOpts.forEach(item => {
                if (arr.includes(item.value)) {
                    opts.push(item);
                }
            });
            return opts;
        }
    },
    methods: {
        /**
         * 获取实际生效的学段：优先用学段下拉选中的值，其次用用户默认学段
         * 返回 '' 表示不过滤学段（全部）
         */
        getEffectivePhase() {
            let dp = this.filters.phase;
            if (dp && dp != '0') {
                return dp;
            }
            return this.userPhase || '';
        },
        /**
         * @name 根据参数请求数据
         */
        queryDataByParams() {
            if (this.contentObject.displaySubjectFilter == true) {
                //加载学科
                this.getSchoolSubject();
            }
            if (this.contentObject.displayGradeFilter == true) {
                // 加载年级
                this.getGradeList();
            }
            if (this.contentObject.displayClassFilter == true) {
                // 加载班级
                this.getSchoolClasses();
            }
            if (this.contentObject.displayYearFilter == true) {
                // 加载学年
                this.getSchoolYears();
            }
            if (this.contentObject.displayProvinceFilter == true) {
                // 加载省份
                this.getAreaData(1, "");
            }
            //   this.$nextTick(()=>{
            //       if(!this.contentObject.displayYearFilter){
            //           this.$emit('filter-data', this.filters,this.$refs.dataFilterHeight.clientHeight,1);
            //       }
            //   })
            this.changeTimeSolt(this.filters.timeSolt)
        },
        /**
         * 选择时间段
         */
        changeTimeSolt(type) {
            this.filters.timeSolt = type;
            let todayStr = this.$utils.getNDayStr(1);
            //反选的情况
            this.filters.endDate = todayStr + ' 23:59:59';
            if (this.filters.timeSolt === 0) {
                // this.filters.timeSolt = 0;
                this.filters.startDate = '';
                this.filters.endDate = '';
            }
            //获取近一周时间
            if (this.filters.timeSolt === 1) {
                this.filters.startDate = this.$utils.getYestodaySevenDayStr(1) + ' 00:00:00';

            } else if (this.filters.timeSolt === 2) {
                //获取近一月时间
                this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 1) + ' 00:00:00';
            } else if (this.filters.timeSolt === 4) {
                //获取近一月时间
                this.filters.startDate = this.$utils.getPreMonthDay(todayStr, 3) + ' 00:00:00';
            }
            if (this.filters.timeSolt != 3) {
                this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 2);
            }
        },
        /**
         * 自定义日期
         */
        customDate(dateList) {
            this.filters.startDate = dateList[0];
            this.filters.endDate = dateList[1];
            this.filters.startDate = this.filters.startDate == "" ? this.filters.startDate : this.filters.startDate + ' 00:00:00';
            this.filters.endDate = this.filters.endDate == "" ? this.filters.endDate : this.filters.endDate + ' 23:59:59';
            this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 3);
        },
        /**
         * 获取学校下的学科信息
         */
        async getSchoolSubject() {
            let _this = this;
            let params = {
                schoolid: _this.schoolId
            };
            // 优先用学段下拉选中的值，其次用用户默认学段
            let phase = this.getEffectivePhase();
            if (phase) {
                params.phase = phase;
            }
            await findSubjectsList(params).then(function (result) {
                _this.subjectList = result.rows;
            }).catch(function (error) {
                _this.$Message.error(error.message);
            });
        },
        /**
         * 获取学校下的年级信息
         */
        async getGradeList() {
            let _this = this;
            let params = {
                schoolid: _this.schoolId
            };
            // 优先用学段下拉选中的值，其次用用户默认学段
            let phase = this.getEffectivePhase();
            if (phase) {
                params.phase = phase;
            }
            let resultData = await findGradeList(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            _this.gradeList = resultData.rows;
            // 记录当前学段下的所有年级id，供"全部年级"时按学段过滤统计接口
            if (_this.gradeList && _this.gradeList.length > 0) {
                _this.phaseGradeIds = _this.gradeList.map(g => g.id).join(',');
            } else {
                _this.phaseGradeIds = '';
            }
            _this.filters.phaseGradeIds = _this.phaseGradeIds;
            // 年级加载完（phaseGradeIds 就绪）后重新通知父组件，避免初次 emit 时 phaseGradeIds 为空导致统计查全校
            if (_this.$refs.dataFilterHeight) {
                _this.$emit('filter-data', _this.filters, _this.$refs.dataFilterHeight.clientHeight, 1);
            }
        },
        /**
         * 获取学年信息
         */
        async getSchoolYears() {
            let _this = this;
            // 有学校id则按学校取真实学年（返回对象数组），否则取全平台学年（返回字符串数组）
            let params = {};
            if (this.schoolId) {
                params.schoolid = this.schoolId;
            }
            await findSchoolYears(params).then(function (result) {
                let data = result;
                _this.yearList = [];
                for (let i = 0; i < data.length; i++) {
                    let yearObj = {};
                    // 兼容两种返回结构：对象数组取 schoolYear，字符串数组直接用
                    let yearName = typeof data[i] === 'object' ? data[i].schoolYear : data[i];
                    yearObj.name = yearName;
                    yearObj.value = yearName;
                    _this.yearList.push(yearObj);
                }
                _this.filters.classyear = _this.yearList[0].value;
                if (_this.contentObject.displayClassFilter == true) {
                    // 加载班级
                    _this.getSchoolClasses();
                }
                _this.$emit('filter-data', _this.filters, _this.$refs.dataFilterHeight.clientHeight, 4);
            }).catch(function (error) {
                _this.$Message.error(error.message);
            });
        },
        /**
         * 获取学校下的班级信息
         */
        async getSchoolClasses() {
            let _this = this;
            let params = {
                schoolid: _this.schoolId,
                gradeid: _this.filters.gradeId == 0 ? '' : _this.filters.gradeId,
                classyear: _this.filters.classyear
            };
            // 优先用学段下拉选中的值，其次用用户默认学段
            let phase = this.getEffectivePhase();
            if (phase) {
                params.phase = phase;
            }
            await findClassesList(params).then(function (result) {
                _this.classList = result.rows;
            }).catch(function (error) {
                _this.$Message.error(error.message);
            });
        },
        /**
         * 获取省市区区域列表
         */
        async getAreaData(type, id) {
            let _this = this;
            let params = {
                type: type,
                id: id
            };
            await findRegion(params).then(function (result) {
                switch (type) {
                    case 1:
                        _this.areaList.provinceList = result;
                        _this.$refs.cityRef.clearSingleSelect();
                        _this.$refs.districtRef.clearSingleSelect();
                        break;
                    case 2:
                        _this.areaList.cityList = result;
                        _this.$refs.cityRef.clearSingleSelect();
                        _this.$refs.districtRef.clearSingleSelect();
                        break;
                    case 3:
                        _this.areaList.districtList = result;
                        _this.$refs.districtRef.clearSingleSelect();
                        break;
                }
                _this.$emit('filter-data', _this.filters, _this.$refs.dataFilterHeight.clientHeight, 5);
            }).catch(function (error) {
                _this.$Message.error(error.message);
            });
        },
        /**
         * 切换选择地区 val: 选取的id type：即将获取的对象类型
         */
        onRegionChange(val, type) {
            let _this = this;
            if (val) {
                if (type) {
                    _this.getAreaData(type, val);
                } else {
                    _this.$emit('filter-data', _this.filters, _this.$refs.dataFilterHeight.clientHeight, 6);
                }
            } else {
                //清空功能下请求数据
                switch (type) {
                    case 2:
                        _this.getAreaData(1, "");
                        break;
                    case 3:
                        _this.getAreaData(2, _this.filters.provinceId == undefined ? '' : _this.filters.provinceId);
                        break;
                    case undefined:
                        _this.getAreaData(3, _this.filters.cityId == undefined ? '' : _this.filters.cityId);
                        break;
                }
            }
        },
        /**
         * 切换学年
         */
        selectYearChange(value) {
            this.filters.classyear = value == undefined ? this.yearList[0].value : value;
            this.filters.classId = '0';
            if (this.contentObject.displayClassFilter == true) {
                this.getSchoolClasses();
            }
            this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 7);
        },
        /**
         * 切换学段
         */
        selectPhaseChange(value) {
            this.filters.phase = value == undefined ? '0' : value;
            // 切换学段后重置年级/班级选择，并按新学段重新加载下拉数据
            this.filters.gradeId = '0';
            this.filters.classId = '0';
            if (this.contentObject.displayGradeFilter == true) {
                this.getGradeList();
            }
            if (this.contentObject.displaySubjectFilter == true) {
                this.getSchoolSubject();
            }
            if (this.contentObject.displayClassFilter == true) {
                this.getSchoolClasses();
            }
            // getGradeList 完成后会自动 emit filter-data，触发统计接口刷新
        },
        /**
         * 切换学科
         */
        selectSubjectChange(value) {
            this.filters.subjectId = value == undefined ? '0' : value;
            this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 9);
        },
        /**
         * 切换年级
         */
        selectGradeChange(value) {
            this.filters.gradeId = value == undefined ? '0' : value;
            this.filters.classId = '0';
            if (this.contentObject.displayClassFilter == true) {
                this.getSchoolClasses();
            }
            this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 10);
        },
        /**
         * 切换班级
         */
        selectClassChange(value) {
            this.filters.classId = value == undefined ? '0' : value;
            this.$emit('filter-data', this.filters, this.$refs.dataFilterHeight.clientHeight, 11);
        }
    },
    mounted() {
        // 同步登录用户学段（供学段下拉限定范围 + 年级/学科/班级过滤）
        this.userPhase = this.$store.getters.phase || '';
        this.queryDataByParams()
    },
    watch: {
        // 监听 store 里 phase 的变化：新窗口打开时 getUserInfo 是异步的，
        // 可能晚于 DataFilter mounted，phase 就绪后需重新加载年级/学科/班级
        '$store.getters.phase'(newVal) {
            let newPhase = newVal || '';
            if (newPhase !== this.userPhase) {
                this.userPhase = newPhase;
                this.queryDataByParams();
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../style/detailPage";
</style>
<style lang="scss">
@import "../style/detailPage";

.data-filter {
    input::-webkit-input-placeholder {
        color: #9f9f9f;
    }

    .ivu-select {
        min-width: 60px;
    }
}

.self-data-filter {
    .ivu-input-wrapper {
        width: vw(220);
    }
}
</style>
